// get_translation_projects
export const GET_TRANSLATION_PROJECT = 'get_translation_projects';
export const GET_TRANSLATION_PROJECT_SUCCESSFUL =
  'get_translation_projects_successfull';
export const GET_TRANSLATION_PROJECT_FAILED = 'get_translation_projects_failed';

// create_translation_project
export const CREATE_TRANSLATION_PROJECT = 'create_translation_project';
export const CREATE_TRANSLATION_PROJECT_SUCCESSFUL =
  'create_translation_project_successfull';
export const CREATE_TRANSLATION_PROJECT_FAILED =
  'create_translation_project_failed';

// update_translation_project
export const UPDATE_TRANSLATION_PROJECT = 'update_translation_project';
export const UPDATE_TRANSLATION_PROJECT_SUCCESSFUL =
  'update_translation_project_successfull';
export const UPDATE_TRANSLATION_PROJECT_FAILED =
  'update_translation_project_failed';

// delete_translation_project
export const DELETE_TRANSLATION_PROJECT = 'delete_translation_project';
export const DELETE_TRANSLATION_PROJECT_SUCCESSFUL =
  'delete_translation_project_successfull';
export const DELETE_TRANSLATION_PROJECT_FAILED =
  'delete_translation_project_failed';
